/** Display labels from the retained development dataset; identifiers and commands stay exact. */
const developmentApi = 'https://api-dev.boostree.partners/glow';
const textFields = new Set([
  'name',
  'title',
  'displayName',
  'clinicName',
  'couponName',
  'categoryTitle',
  'label',
  'caption',
  'heading',
  'question',
  'answer',
  'body',
  'content',
  'description',
  'summary',
  'subtitle',
  'intro',
  'greeting',
  'headline',
  'text',
  'message',
  'helpText',
  'goalText',
  'career',
  'specialties',
  'nameOverride',
  'titleTranslations',
  'translations',
  'author',
  'address',
  'desiredSchedule',
  'location',
  'instructions',
  'bodyOriginal',
  'hotelName',
  'hotelAddress',
  'companions',
  'emergencyContact',
  'requests',
  'quote',
  'reason',
  'note',
]);
const localeFields = new Set(['en', 'zh-CN', 'ko', 'ja']);
const marker =
  /(?:\[\s*DEV[ \t_-]+(?:MOCK|SAMPLE)\s*\]|(?<![\p{L}\p{N}_@/-])DEV[ \t]+(?:MOCK|SAMPLE)(?![\p{L}\p{N}_@/-]))[ \t]*(?:[—–:][ \t]*)?/giu;

export function isDevelopmentLabelResponse(baseURL?: string) {
  return baseURL?.replace(/\/$/, '') === developmentApi;
}

function displayText(value: string) {
  const cleaned = value.replace(marker, '');
  return cleaned === value ? value : cleaned.trim() || 'Sample';
}

/** Only named display text and its translations are copied. No mutation of the source response. */
export function withoutDevelopmentLabels<T>(value: T): T {
  function visit(current: unknown, display = false): unknown {
    if (typeof current === 'string')
      return display ? displayText(current) : current;
    if (Array.isArray(current)) {
      const next = current.map((item) => visit(item, display));
      return next.some((item, index) => item !== current[index])
        ? next
        : current;
    }
    if (!current || typeof current !== 'object') return current;
    const textAnswer =
      'value' in current &&
      (('questionType' in current && current.questionType === 'TEXT') ||
        ('code' in current &&
          typeof current.code === 'string' &&
          'label' in current &&
          typeof current.label === 'string'));
    const entries = Object.entries(current);
    const translated =
      display && entries.every(([key]) => localeFields.has(key));
    let changed = false;
    const next = Object.fromEntries(
      entries.map(([key, item]) => {
        const result = visit(
          item,
          translated || textFields.has(key) || (textAnswer && key === 'value'),
        );
        changed ||= result !== item;
        return [key, result];
      }),
    );
    return changed ? next : current;
  }
  return visit(value) as T;
}
